module.exports = __webpack_public_path__ + "img/avatar18_11zon.4e19cd40.webp";